import { render, staticRenderFns } from "./UpstreamAndDownstreamRiskMobile.vue?vue&type=template&id=15c5db7c&scoped=true"
import script from "./UpstreamAndDownstreamRiskMobile.vue?vue&type=script&lang=js"
export * from "./UpstreamAndDownstreamRiskMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c5db7c",
  null
  
)

export default component.exports